export default {
  title: '{{plan}} è attivo',
  plan: 'Piano: {{plan}}',
  free_until: 'Gratuito fino al {{date}}',
  continue: 'Continua',
};
